import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { AlertTriangle, Home, RefreshCw } from 'lucide-react';
import Header from '../components/blog/Header';
import Footer from '../components/blog/Footer';
import { Container } from '../components/ui/Container';
import { Button } from '../components/ui/Button';
import SEO from '../components/seo/SEO';

const PageWrapper = styled.div`
  min-height: 100vh;
  background-color: ${props => props.theme.colors.background};
  display: flex;
  flex-direction: column;
`;

const Main = styled.main`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 0;
  
  ${Container} {
    text-align: center;
  }
`;

const ErrorIcon = styled.div`
  width: 5rem;
  height: 5rem;
  margin: 0 auto 2rem;
  color: ${props => props.theme.colors.error || '#ef4444'};
  
  @media (min-width: 1024px) {
    width: 6rem;
    height: 6rem;
    margin-bottom: 2.5rem;
  }
  
  svg {
    width: 100%;
    height: 100%;
  }
`;

const ErrorTitle = styled.h1`
  font-family: ${props => props.theme.typography.fonts.display};
  font-size: 2rem;
  font-weight: ${props => props.theme.typography.fontWeights.semibold};
  margin-bottom: 1rem;
  
  @media (min-width: 768px) {
    font-size: 2.5rem;
  }
  
  @media (min-width: 1024px) {
    font-size: 3rem;
    margin-bottom: 1.5rem;
  }
`;

const ErrorMessage = styled.p`
  font-size: 1rem;
  color: ${props => props.theme.colors.mutedForeground};
  margin-bottom: 2rem;
  line-height: 1.7;
  max-width: 32rem;
  margin-left: auto;
  margin-right: auto;
  
  @media (min-width: 1024px) {
    font-size: 1.125rem;
    margin-bottom: 2.5rem;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
`;

const Error500 = () => {
  return (
    <PageWrapper>
      <SEO
        title="Server Error"
        description="We encountered a server error. Please try again later."
        noindex
      />
      <Header />
      <Main>
        <Container>
          <ErrorIcon>
            <AlertTriangle />
          </ErrorIcon>
          <ErrorTitle>500 - Server Error</ErrorTitle>
          <ErrorMessage>
            We're experiencing some technical difficulties. Our team has been notified and is working to fix the issue. 
            Please try again in a few moments.
          </ErrorMessage>
          <ButtonGroup>
            <Button as={Link} to="/" variant="primary">
              <Home />
              Go Home
            </Button>
            <Button
              variant="secondary"
              onClick={() => window.location.reload()}
            >
              <RefreshCw />
              Refresh Page
            </Button>
          </ButtonGroup>
        </Container>
      </Main>
      <Footer />
    </PageWrapper>
  );
};

export default Error500;



